import React, {useEffect, useState} from 'react'
import {Button, Card, Table} from "antd";
import {getRelevantPersonByCustomer} from "../../services/serviceRelevantPerson";
import {useParams} from "@reach/router";
import RelevantCreate from "./RelevantCreate";
import RelevantActions from "./RelevantActions";

const RelevantPerson = () => {
    const {customerId} = useParams()
    const [updateList, setListUpdate] = useState(false)
    const [sortedList, setSortedList] = useState([])
    const [newModal, setNewModal] = useState(false)

    useEffect(() => {
        getRelevantPersonByCustomer(customerId)
            .then(({data}) => {
                handlers.sortData(data)
            })
    }, [updateList])

    const handlers = {
        updater() {
            setListUpdate(!updateList)
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            let sorted = []
            list.forEach(item => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    relName: item.name,
                    relSurname: item.surname,
                    relTitle: item.title,
                    relInternal: item.internalPhoneCode,
                    relPhone: item.phone,
                    customerId: item.customer.id

                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    }

    const columns = [
        {
            title: 'Temsilci Adı',
            dataIndex: 'relName',
            key: 'relName',
            render: (t, r) => `${t} ${r.relSurname}`
        },
        {
            title: 'Temsilci Ünvanı',
            dataIndex: 'relTitle',
            key: 'relTitle'
        },
        {
            title: 'Temsilci Tel',
            dataIndex: 'relPhone',
            key: 'relPhone'
        },
        {
            title: 'Dahili',
            dataIndex: 'relInternal',
            key: 'relInternal'
        },
        {
            title: 'İşlemler',
            render: (t, r) => <RelevantActions record={r} updater={handlers.updater} />
        }
    ]

    return (
        <React.Fragment>
            <Card
                title={'İlgililer Listesi'}
                extra={[
                    <Button
                        type={'primary'}
                        key={'CreateButton'}
                        onClick={() => setNewModal(!newModal)}
                    >
                        Yeni Ekle
                    </Button>
                ]}
            >

                <Table scroll={{x: 'max-content'}} columns={columns} dataSource={sortedList}/>

            </Card>

            {
                newModal ? <RelevantCreate show={newModal} updater={handlers.updater}
                                           modalCloser={handlers.modalCloser}/> : null
            }

        </React.Fragment>
    )
}
export default RelevantPerson